import { useMemo } from 'react';
import { compressImg } from '../util/imgLoader';

export const useRichImage = function (imageUrl: string, quality = 80) {
  return useMemo(() => {
    return compressImg({ imageUrl, quality });
  }, [imageUrl]);
};
